import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import Button from "@/components/Button/index";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ToastContext } from "@/context/toast/index";
import eclipsapi from "@/services/api/eclips.js";
import packagesApi from "@/services/api/packages.js";
import api from "@/services/api/messages.js";
import rem from "@/utils/rem";
import { useContext, useEffect, useState } from "react";
import { useParams } from "@/lib/router-dom/index";
import { feature } from "@/utils/feature-verifier";
import { featureConstant } from "@/constants/configuration/feature";
import { ReactComponent as IconConfigure } from '@/assets/svgs/icon-configure.svg';

export default function DownloadDataModal({ visible, close, dataElementId, messageStoreId, all, isPackage, defaultFileType = "", defaultIncludeAttachments = false, defaultTotalFiles = 0, packageName }) {

	const [fileSize, setFileSize] = useState("");
	const [totalFiles, setTotalFiles] = useState(defaultTotalFiles)
	const [fileType, setFileType] = useState(defaultFileType);
	const [loading, setLoading] = useState(false);
	const [includeAttachments, setIncludeAttachments] = useState(defaultIncludeAttachments);
	const { addToastMessage } = useContext(ToastContext);

	const { eclipId } = useParams()

	async function checkFileSize() {
		setLoading(true);
		const [error, data] = await api.checkFileSize({
			id: messageStoreId,
		});
		setLoading(false);

		if (error) {
			return addToastMessage(
				error?.error?.message || "Unable to retrieve Config",
				"error"
			);
		}

		setFileSize(isNaN(data.totalFileSize) ? "0" : data.totalFileSize);
		setTotalFiles(data.totalFiles);
	}

	async function downloadFile() {
		setLoading(true);
		if (isPackage) {
			const [error, _response] = await packagesApi.createActivityLog(eclipId, {
				dataElementId,
				type: all ? 'downloadall' : "download",
			});

			if (error) {
				addToastMessage("Failed to add to activity log", "error")
			}
		}

		if (!isPackage) {
			const [error, _response] = await eclipsapi.createActivityLog(eclipId, {
				dataElementId,
				type: all ? 'downloadall' : "download",
			});

			if (error) {
				addToastMessage("Failed to add to activity log", "error")
			}
		}

		const [error, result] = await api.downloadFile(
			{
				id: messageStoreId,
			},
			fileType,
			{
				params: {
					includeAttachments: includeAttachments,
				},
			}
		);
		setLoading(false);

		if (error) {
			return addToastMessage(
				error?.error?.message || "Unable to download file",
				"error"
			);
		}

		const link = document.createElement("a");
		if (includeAttachments == "false" && messageStoreId.length === 1) {
			if (fileType === "json") {
				const path = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(result, null, 2))}`
				link.href = path;
				link.download = `${dataElementId + ".json"}`;
				link.click();
				setFileType()
				setIncludeAttachments()
				close()
				return;
			}
			if (fileType === "csv") {
				const path = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURIComponent(result)}`
				link.href = path;
				link.download = `${dataElementId + ".csv"}`;
				link.click();
				setFileType()
				setIncludeAttachments()
				close()
				return;
			}
		}

		const path = `data:application/zip;base64,${result}`;
		link.href = path;
		link.download = `${packageName + ".zip"}`;
		link.click();
		setFileType()
		setIncludeAttachments()
		close()
	}

	useEffect(() => {
		if (messageStoreId?.length > 0 && visible) {
			checkFileSize();
		}
	}, [messageStoreId, visible]);

	return (
		<Modal visible={visible} variant="medium" close={() => {
			close()
			setFileType()
			setIncludeAttachments()
		}}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconConfigure />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Download Package Data
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="download-transaction__rows">
							<div className="download-transaction__row">
								You are about to export this transactions (
								{fileSize}MB)
							</div>
							<div className="download-transaction__row">
								<div className="download-transaction__row__left">
									Export data as
								</div>
								<div className="download-transaction__row__right">
									<div className="download-transaction__row__right__radio">
										<input
											type="radio"
											value="json"
											name="fileType"
											id="json"
											onClick={(e) =>
												setFileType(e.target.value)
											}
										/>
										<label htmlFor="json">JSON</label>
									</div>
									<div className="download-transaction__row__right__radio">
										<input
											type="radio"
											value="csv"
											name="fileType"
											id="csv"
											onClick={(e) =>
												setFileType(e.target.value)
											}
										/>
										<label htmlFor="csv">CSV</label>
									</div>
								</div>
							</div>
							<div className="download-transaction__row">
								<div className="download-transaction__row__left">
									Include attachments
								</div>
								<div className="download-transaction__row__right">
									<div className="download-transaction__row__right__radio">
										<input
											type="radio"
											value={true}
											name="includeAttachment"
											id="yes"
											onClick={(e) =>
												setIncludeAttachments(
													e.target.value
												)
											}
											checked={includeAttachments == "true"}
											disabled={fileSize > 250 || totalFiles === 0}
										/>
										<label htmlFor="yes">Yes</label>
										{fileSize > 250 && (
											<span className="download-transaction__row__right__radio__message">
												Download size is too large
											</span>
										)}
									</div>
									<div className="download-transaction__row__right__radio">
										<input
											type="radio"
											value={false}
											name="includeAttachment"
											id="no"
											onClick={(e) =>
												setIncludeAttachments(
													e.target.value
												)
											}
										/>
										<label htmlFor="no">No</label>
										<span className="download-transaction__row__right__radio__message">
											&nbsp; (download data only)
										</span>
									</div>
								</div>
							</div>
						</div>
						{/* <div style={{ fontSize: rem(14), textAlign: 'center' }}>Do you want to configure your API ?</div> */}
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button
							text="Download"
							data-testid="download-btn"
							loading={loading}
							disabled={(!fileType || !includeAttachments || Number.parseFloat(fileSize) <= 0)}
							submit={() => {
								// goTo('/configuration/api-configuration')
								downloadFile();
							}}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
}
